/**
 * Generiert einen String der Laenge length aus dem characters seed
 *
 * @param {number} length - Die Laenge des zu generierende Strings
 * @param {string} [characters] - Der Seed
 */
function generateRandomString(length, characters = "abcdefghijklmnopqrstuvqxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return Array(length)
        .fill(0)
        .map(it => characters[Math.floor(Math.random() * characters.length)])
        .join("")
}


function determineTextColor(backgroundColor) {
    // expects color from "window.computedStyle(elem).backgroundColor"
    let rgbMatch = backgroundColor.match(/\d+/g);
    const rgb = rgbMatch ? rgbMatch.map(Number) : null;
    return luminance(rgb[0], rgb[1], rgb[2]) > 0.5 ? 'black' : 'white';
}

/** whether the current tab is the active one (or the last one active) */
let isActiveTab = true; // we start of as active (obviously)
(function() {
    const channel = new BroadcastChannel("docsy-tabCoordination");
    const tabId = crypto.randomUUID();
    channel.onmessage = function () { isActiveTab = false };
    function checkTabVisibility() {
        // we do not set isActiveTab false, as we want to know the last active tab as well
        if (document.visibilityState !== "visible") return;
        isActiveTab = true;
        channel.postMessage({ tabId });
    }
    document.addEventListener("visibilitychange", checkTabVisibility);
    channel.postMessage({ tabId });
})();